import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
    getWarehouseTransferList as getWarehouseTransferListApi,
    getWarehouseTransfer as getWarehouseTransferApi,
    addNewWarehouseTransfer as addNewWarehouseTransferApi,
    updateWarehouseTransfer as updateWarehouseTransferApi,
    deleteWarehouseTransfer as deleteWarehouseTransferApi,
} from '../../helpers/warehouse/backend_helper';

export const getWarehouseTransferList = createAsyncThunk('warehouses/getWarehouseTransferList', async () => {
    try {
        const response = getWarehouseTransferListApi();
        return response;
    } catch (error) {
        throw new Error(error);
    }
});

export const getWarehouseTransfer = createAsyncThunk('warehouses/getWarehouseTransfer', async warehouse_id => {
    try {
        const response = getWarehouseTransferApi(warehouse_id);
        return response;
    } catch (error) {
        throw new Error(error);
    }
});

export const addNewWarehouseTransfer = createAsyncThunk('warehouses/addNewWarehouseTransfer', async warehouse => {
    try {
        const response = addNewWarehouseTransferApi(warehouse);
        toast.success('Bodega agregado exitosamente.', { autoClose: 3000 });
        return response;
    } catch (error) {
        toast.error('Error al agregar warehouse.', { autoClose: 3000 });
        throw new Error(error);
    }
});

export const updateWarehouseTransfer = createAsyncThunk('warehouses/updateWarehouseTransfer', async (warehouse) => {
    try {
        const response = updateWarehouseTransferApi(warehouse);
        toast.success('Bodega actualizado exitosamente', { autoClose: 3000 });
        return response;
    } catch (error) {
        toast.error('Error al actualizar warehouse.', { autoClose: 3000 });
        throw new Error(error);
    }
}
);

export const deleteWarehouseTransfer = createAsyncThunk('warehouses/deleteWarehouseTransfer', async warehouse => {
    try {
        const response = await deleteWarehouseTransferApi(warehouse);
        toast.success('Bodega eliminado exitosamente.', { autoClose: 3000 });
        return { warehouse, ...response };
    } catch (error) {
        toast.error('Error al eliminar warehouse.', { autoClose: 3000 });
        throw new Error(error);
    }
});